import React, {useEffect, useState} from 'react';
import MerchantEnrollmentAPI from "../../api/MerchantEnrollmentAPI";
import CompanyInformationForm from "../../components/Enrollment/CompanyInformationForm";
import EmployeesInformationForm from "../../components/Enrollment/EmployeesInformationForm";
import InformationConfirmation from "../../components/Enrollment/InformationConfirmation";

function FormsTemplate({handleNext, currentStep}) {
    const {CorporateAutoFillData, autofillData, GetEmployeeNames, employeesList, SaveCorporateEnrollmentData, uploadLoading} = MerchantEnrollmentAPI();
    const [data, setData] = useState(null);
    const [validData1, setValidData1] = useState(true);
    const [validData2, setValidData2] = useState(false);


    useEffect(() => {
        setData({
            generalInformation: autofillData?.generalInformation,
            EmployeeInformation: autofillData?.employeeInformation,
            EmployeeLimitations: null,
            CompanyLogo: null,
        })
    }, [autofillData]);


    useEffect(() => {
        CorporateAutoFillData();
    }, []);

    const handleSecondStep = () => {
        GetEmployeeNames(data.EmployeeInformation);
        handleNext();
    }

    const handleThirdStep = () => {
        const payload = {
            EmployeeLimitations: data.EmployeeLimitations,
            CompanyLogo: data.CompanyLogo,
            GeneralInformation: data.generalInformation,
            EmployeeInformation: JSON.stringify(data.EmployeeInformation),
        }

        SaveCorporateEnrollmentData(payload);
    }

    return (
        <div className="form-template">
            {
                currentStep === 1 &&
                <>
                    <CompanyInformationForm data={autofillData?.generalInformation} getData={data} setData={setData}
                                            setValidData={setValidData1}/>
                    <button onClick={handleNext} className="continue-btn" disabled={!validData1}>Continue</button>
                </>
            }

            {
                currentStep === 2 &&
                <>
                    <EmployeesInformationForm employeesList={autofillData.employeeInformation} data={data}
                                              setData={setData}
                                              setValidData={setValidData2}/>
                    <button onClick={handleSecondStep} className="continue-btn" >Continue</button>
                </>
            }

            {
                currentStep === 3 &&
                <>
                    <InformationConfirmation data={data} employeesList={employeesList}/>
                    <button onClick={handleThirdStep} className="continue-btn"
                            disabled={!validData1 || !validData2}>Confirm
                    </button>
                </>

            }

            {/*<button onClick={handlePrevious} >Previous</button>*/}
        </div>
    );
}

export default FormsTemplate;

